import { render, staticRenderFns } from "./field.vue?vue&type=template&id=13b2a2a2&"
import script from "./field.vue?vue&type=script&lang=ts&"
export * from "./field.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports